import { withInstall } from '@zoryn/utils'
import Statistic from './src/statistic.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZStatistic: SFCWithInstall<typeof Statistic> =
  withInstall(Statistic)

export default ZStatistic
export * from './src/statistic'
